export const LOCAL_COOKIE = 'pp_cookiebar_displayed'
export const LOCAL_HAS_VISITED = 'has_visited'
